<span *ngFor="let textWidth of texts" class="holder"
  [style.width.px]="textWidth"
  [style.margin]="'0 ' + textMargin + 'px'"
  [style.backgroundColor]="color"
  [style.transform]="'scaleY(' + scaleY + ')'"
>&nbsp;</span>
